import React, { useState, useEffect, useRef, useMemo } from "react";
import StyleRenderer from "../StyleRenderer";
import PlaylistVideoPlayer from "../PlaylistVideoPlayer";
// import PlaylistVideoPlayer from "./PlaylistVideoPlayer";
// import StyleRenderer from "./StyleRenderer";

const PlaylistClassic = ({ attributes, nonce }) => {
  const { videos, styles, options, uniqueId } = attributes;
  const [currentVideo, setCurrentVideo] = useState(videos?.[0] || {});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [player, setPlayer] = useState(null);
  const ref = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        // ref.current.querySelector(".video__right").style.height = ref.current.querySelector(".video__left .video__main").offsetHeight + "px";
      }
    }, 100);
  }, [currentVideo]);

  useEffect(() => {
    if (ref.current) {
      let maxTitleHeight = "50px";
      const titles = ref.current.querySelectorAll(".video_title .title");
      titles.forEach((title) => {
        const height = getComputedStyle(title).height;
        if (height > maxTitleHeight) {
          maxTitleHeight = height;
        }
      });

      titles.forEach((title) => (title.style.height = maxTitleHeight));

      jQuery(ref.current.querySelector(".list_items")).owlCarousel({
        nav: true,
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 2,
          },
          769: {
            items: 3,
          },
        },
      });
      ref.current.querySelector(".list_items").classList.add("owl-carousel");
      ref.current.querySelectorAll(".h5vp_playlist_item").forEach((item) => item.addEventListener("click", (e) => e.preventDefault()));
    }
  }, []);

  useEffect(() => {
    if (player && options.autoplayNextVideo) {
      player.on("ended", () => {
        const currentVideo = document.querySelector(`.item-active`);
        // window.currentVideo = currentVideo;
        const nextIndex = currentVideo.nextElementSibling?.dataset?.index || 0;
        // console.log({ nextIndex });
        if (nextIndex) {
          setCurrentIndex(nextIndex);
        }
      });
    }
  }, [player]);

  useEffect(() => {
    window.currentIndex = currentIndex;
    setCurrentVideo(videos[currentIndex] || videos[0]);
    document.querySelectorAll(`.item-active`).forEach((item) => {
      item.classList.remove("item-active");
    });
    document.querySelector(`.video-item[data-index="${currentIndex}"]`)?.classList.add("item-active");
    console.log({ currentIndex });
  }, [currentIndex]);

  return (
    <div id={uniqueId} className={`video video--bg listwithposter`} ref={ref}>
      <StyleRenderer styles={styles} uniqueId={uniqueId} />
      <div className="h5vp_playlist_container ">
        <div className="video__top video__wrapper">
          <PlaylistVideoPlayer video={currentVideo} options={options} player={player} setPlayer={setPlayer} />
        </div>
        <div className="video__top list_items ">
          {videos.map((video, index) => (
            <>
              <li
                key={index}
                className={`video-item video-item-${index} ${currentIndex === index ? "item-active" : ""}`}
                onClick={() => {
                  setCurrentVideo(video);
                  setCurrentIndex(index);
                }}
                data-index={index}
              >
                <a href="#" className="h5vp_playlist_item" data-provider={video.h5vp_video_provider} data-poster={video.video_thumb} data-videoindex="0" data-source={video.h5vp_video_source}>
                  <div className="overlay"></div>
                  {video.video_thumb ? <img decoding="async" className="video_thumb" src={video.video_thumb} alt="" /> : <div className="noImage"></div>}

                  <div className="svg">
                    {currentIndex === index ? (
                      <svg aria-hidden="true" focusable="false">
                        <use xlinkHref="#plyr-pause"></use>
                      </svg>
                    ) : (
                      <svg aria-hidden="true" focusable="false">
                        <use xlinkHref="#plyr-play"></use>
                      </svg>
                    )}
                  </div>
                  <video src="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4" style={{ display: "none" }}></video>
                </a>
                <div className="video_title">
                  <h3 className="title">{video.video_title}</h3>
                </div>
              </li>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlaylistClassic;
